import React, {ReactElement} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {Link} from 'gatsby';

import {Locale, useLocale} from '../../../RootProvider/LocaleContext';
import {ReactComponent as BusinessLoansIcon} from '../../../images/icons/handHoldingCoinYellowShadow.svg';
import {ReactComponent as InvoiceFinanceIcon} from '../../../images/icons/invoiceYellowShadow.svg';
import {ReactComponent as AssetFinanceIcon} from '../../../images/icons/vanYellowShadow.svg';
import {ReactComponent as PropertyDevelopment} from '../../../images/icons/industryYellowShadow.svg';
import {ReactComponent as CommercialMortgages} from '../../../images/icons/storeYellowShadow.svg';
import {ReactComponent as WorkingCapital} from '../../../images/icons/exchangingCoinsYellowShadow.svg';
import {ReactComponent as BusinessCreditCards} from '../../../images/icons/creadiCardMagneticStripeYellowShadow.svg';
import Paragraph, {FontWeight} from '../../DesignSystem/Text/Paragraph/Paragraph';

import './OurProducts.scss';
import {Alignment} from '../../../types';

function OurProductsLinks(): ReactElement {
  const locale = useLocale();
  const {formatMessage} = useIntl();

  return (
    <div className="ourProducts__links">
      <Link
        to={formatMessage({id: 'homepage.ourProducts.links.businessLoans.href'})}
        className="ourProducts__button unstyledLink"
      >
        <BusinessLoansIcon />
        <Paragraph alignment={Alignment.CENTER} fontWeight={FontWeight.SEMIBOLD}>
          <FormattedMessage id="homepage.ourProducts.links.businessLoans.text" />
        </Paragraph>
      </Link>
      <Link
        to={formatMessage({id: 'homepage.ourProducts.links.invoiceFinance.href'})}
        className="ourProducts__button unstyledLink"
      >
        <InvoiceFinanceIcon />
        <Paragraph alignment={Alignment.CENTER} fontWeight={FontWeight.SEMIBOLD}>
          <FormattedMessage id="homepage.ourProducts.links.invoiceFinance.text" />
        </Paragraph>
      </Link>
      <Link
        to={formatMessage({id: 'homepage.ourProducts.links.assetFinance.href'})}
        className="ourProducts__button unstyledLink"
      >
        <AssetFinanceIcon />
        <Paragraph alignment={Alignment.CENTER} fontWeight={FontWeight.SEMIBOLD}>
          <FormattedMessage id="homepage.ourProducts.links.assetFinance.text" />
        </Paragraph>
      </Link>
      <Link
        to={formatMessage({id: 'homepage.ourProducts.links.propertyDevelopment.href'})}
        className="ourProducts__button unstyledLink"
      >
        <PropertyDevelopment />
        <Paragraph alignment={Alignment.CENTER} fontWeight={FontWeight.SEMIBOLD}>
          <FormattedMessage id="homepage.ourProducts.links.propertyDevelopment.text" />
        </Paragraph>
      </Link>
      {![Locale.nl].includes(locale) && (
        <Link
          to={formatMessage({id: 'homepage.ourProducts.links.commercialMortgages.href'})}
          className="ourProducts__button unstyledLink"
        >
          <CommercialMortgages />
          <Paragraph alignment={Alignment.CENTER} fontWeight={FontWeight.SEMIBOLD}>
            <FormattedMessage id="homepage.ourProducts.links.commercialMortgages.text" />
          </Paragraph>
        </Link>
      )}
      <Link
        to={formatMessage({id: 'homepage.ourProducts.links.workingCapital.href'})}
        className="ourProducts__button unstyledLink"
      >
        <WorkingCapital />
        <Paragraph alignment={Alignment.CENTER} fontWeight={FontWeight.SEMIBOLD}>
          <FormattedMessage id="homepage.ourProducts.links.workingCapital.text" />
        </Paragraph>
      </Link>
      <Link
        to={formatMessage({id: 'homepage.ourProducts.links.businessCards.href'})}
        className="ourProducts__button unstyledLink"
      >
        <BusinessCreditCards />
        <Paragraph alignment={Alignment.CENTER} fontWeight={FontWeight.SEMIBOLD}>
          <FormattedMessage id="homepage.ourProducts.links.businessCards.text" />
        </Paragraph>
      </Link>
    </div>
  );
}

export default OurProductsLinks;
